import {
  MessageType,
  MessageTypeList,
} from "@intelligems/ig-types/schemas/plugin-debug-types";

import { apiClient } from "../api/api";

import { IgStorage } from "./igStorage";
import { message } from "./message";

export function widgetAuth() {
  let port;
  const handleMessage = async (e: MessageEvent) => {
    console.log({ "frontend received": e });
    const type: MessageType = e.data?.type;
    if (!MessageTypeList.includes(type)) {
      return null;
    }

    if (type === "LOGIN_AS_ORG") {
      console.log({ loginAsOrg: e.data.id });
      if (!e.data.id) {
        console.warn("No orgId provided");
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const storedToken = IgStorage.widgetToken;
      const widgetAuth = urlParams.get("widgetAuth");

      if (!storedToken) {
        console.warn("No stored token");
        message({
          type: "NOT_LOGGED_IN",
          payload: {
            message: "Not logged in",
          },
        });
        return;
      }

      try {
        const baseURL = import.meta.env.VITE_BASE_URL;

        const resp = await (
          await fetch(`${baseURL}/v2/login`, {
            method: "POST",
            body: JSON.stringify({
              orgId: e.data.id,
              token: storedToken,
            }),
            headers: {
              "Content-Type": "application/json",
            },
          })
        ).json();

        const { token, organization } = resp;

        const payload = {
          ...organization,
          token,
        };

        message({
          type: "LOGGED_IN",
          payload,
        });
      } catch (e) {
        console.error(e);
      }
    } else if (e.data.type === "igRequest") {
      const currentPort = e.ports[0];
      port = currentPort;

      apiClient
        .request({
          ...e.data.request,
          baseURL: import.meta.env.VITE_BASE_URL,
        })
        .then(({ status, data, statusText, headers }) => {
          currentPort.postMessage({
            status,
            statusText,
            data,
            headers,
            uuid: e.data.uuid,
          });
        })
        .catch((err) => {
          currentPort.postMessage({
            status: err?.status || 500,
            data: {
              errors: [JSON.parse(JSON.stringify(err))],
            },
            uuid: e?.data?.uuid,
          });
        });
    }
  };

  //eslint-disable-next-line @typescript-eslint/no-misused-promises
  window.addEventListener("message", handleMessage);
  message({ type: "READY" });
}
